function cleanPhoneNumber(phone: string): string {
  return phone.replace(/[^\d+]/g, "").replace(/\+(?!^)/g, "");
}

export default function isPhoneValid(phone?: string): boolean {
  if (!phone) return false;

  const cleanedPhone = cleanPhoneNumber(phone);

  return /^\+?\d{10,15}$/.test(cleanedPhone);
}

export interface PhoneValidationMessages {
  required: string;
  minDigits: string;
  maxDigits: string;
  invalid: string;
}

export function validatePhoneNumber(
  value: string,
  required: boolean = false,
  messages: PhoneValidationMessages,
): string | true {
  if (!value?.trim()) {
    return required ? messages.required : true;
  }

  const cleanedPhone = cleanPhoneNumber(value);

  if (cleanedPhone.length < 10) {
    return messages.minDigits;
  }

  if (cleanedPhone.length > 15) {
    return messages.maxDigits;
  }

  return isPhoneValid(value) ? true : messages.invalid;
}
